<template>
  <div class="cso-redesign-box"
       :class="{'has-overlay': hasOverlay, 'big-box': bigBox, 'no-padding': noPadding}">
    <i v-if="hasOverlay" aria-label="Ladeanimation" role="img"></i>
    <slot></slot>
    <div class="focus-end-guard" :tabindex="isEditing ? 0 : -1"></div>
  </div>
</template>
<script>
export default {
  name: 'CsoRedesignBox',
  props: {
    hasOverlay: {
      type: Boolean,
      required: false,
      default: false
    },
    bigBox: {
      type: Boolean,
      required: false,
      default: false
    },
    noPadding: {
      type: Boolean,
      required: false,
      default: false
    },
    isEditing: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mounted () {
    const end = this.$el.querySelector('.focus-end-guard')
    const getFirstElement = () => this.$el.querySelector('select,input,[tabindex="0"]')
    end.addEventListener('focus', () => getFirstElement()?.focus())
  }
}
</script>
<style lang="scss">
.cso-redesign-box {
  @include box-shadow-redesign();
  background-color: $white;
  padding: 24px 32px;
  color: $black;
  font-family: $font-family-regular;
  font-size: 16px;
  line-height: 24px;

  .component-state.error {
    box-shadow: none;
    padding: 20px 0;

    @include sm {
      padding: 20px 10px;
    }
  }

  &.big-box {
    padding: 48px;

    @include md {
      padding: 24px 20px;
    }

    @include sm {
      padding: 24px 16px;
    }
  }

  &.no-padding {
    padding: 0;
  }

  @include print-view {
    padding: 0 20px;
  }

  @include md {
    padding: 24px 20px;
  }

  h2, .box-header {
    font-family: $font-family-display;
    font-size: 24px;

    @include md {
      font-size: 22px;
    }
  }

  h3 {
    font-family: $font-family-display;
    font-size: 20px;

    @include md {
      font-size: 18px;
    }
  }

  .box-header {
    border-bottom: 1px solid $gray-light;
    padding-bottom: 16px;
    margin-bottom: 16px;
  }

  .box-editable-buttons {
    @include hidden-print();
    border-top: 1px solid $gray-light;
    padding-top: 16px;
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
    align-items: center;

    .button--link-blue {
      min-width: auto;
      padding: 0;
    }

    .mobile-only {
      display: none;
    }

    @include sm {
      flex-direction: column !important;

      .desktop-only {
        display: none;
      }

      .mobile-only {
        display: initial;
      }

      button, a {
        width: 100%;
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    &.only-link,
    &.direction-row {
      flex-direction: row;
    }
  }

  .info-box {
    text-align: left;
    font-size: 14px;
    line-height: 17.5px;;
    background: $yellow-light;
    padding: 8px 12px;
  }

  .success-box,
  .neutral-box,
  .warning-box,
  .error-box {
    font-size: 14px;
    line-height: 17.5px;;
    padding: 12px 16px;
    margin-bottom: 16px;
    display: flex;
    flex-direction: row;

    @include sm {
      margin-bottom: 8px;
    }

    i.icon {
      content: '';
      background-size: 50%;
      background-position: center;
      background-repeat: no-repeat;
      width: 48px;
      height: 48px;
      display: block;
      background-color: $white;
      border-radius: 50%;
      margin-right: 12px;
      flex-shrink: 0;

      @include sm {
        display: none;
      }
    }

    p {
      margin-bottom: 0;
      align-self: center;
      font-family: $font-family-bold;
    }
  }

  .success-box {
    background: $green-pale;
    border-left: 4px solid $green-2B;

    i.checkmark {
      background-image: url("/static/icons/check.svg");
    }
  }

  .neutral-box {
    background: $blue-lighter;
    border-left: 4px solid $blue;

    i.info {
      background-image: url("/static/icons/information-blue.svg");
    }

    p {
      font-family: $font-family-regular;
    }
  }

  .error-box {
    background: $light-red;
    border-left: 4px solid $red-b6;

    i.info {
      background-image: url("/static/icons/alert_round.svg");
    }
  }

  .warning-box {
    background: $yellow-light;
    border-left: 4px solid $yellow;

    i.warning {
      background-image: url("/static/icons/alert.svg");
    }

    i.mail {
      background-image: url("/static/icons/mail.svg");
    }

    i.phone {
      background-image: url("/static/icons/phone.svg");
    }

    button {
      margin-bottom: 0;
      min-width: 156px;

      @include sm {
        margin-top: 12px;
      }
    }
  }

  p {
    font-size: inherit;
    line-height: inherit;
  }

  .pad10 {
    padding-bottom: 10px;
  }

  .pad30 {
    padding-bottom: 30px;
  }
}
</style>
